<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-full-tablet is-6-desktop">
        <!-- Review Breakdown -->
        <div class="card" data-track="Review Breakdown">
          <header class="card-header is-hidden-mobile">
            <p class="card-header-title">Review&nbsp;<span class="has-text-weight-normal">breakdown</span></p>
            <p class="card-header-icon has-text-weight-normal">
              <drop-down data-track="select period" place-holder="Filter by date..." :items="filterList" v-on:changed="reviewFilterSelected" :select-first-item-on-mount="selectFirstOption"></drop-down>
            </p>
          </header>
          <header class="card-header is-hidden-tablet">
            <p class="card-header-title">Review&nbsp;<span class="has-text-weight-normal">breakdown</span></p>
            <p class="is-fullwidth"><drop-down data-track="select period" :is-full-width="mobileIsFullWidthDropdown" place-holder="Filter by date..." :items="filterList" v-on:changed="reviewFilterSelected" :select-first-item-on-mount="selectFirstOption"></drop-down></p>
          </header>
          <div class="card-content">
            <div v-if="!isFetchingReviewBreakdownData">
              <article class="media grey-back">
                <div class="media-left">
                  <figure class="image is-41x35">
                    <img src="/static/img/reviews/reviews.svg" alt="Total number of reviews" />
                  </figure>
                </div>
                <div class="media-content">
                  <p class="is-size-6 is-height-35">TOTAL&nbsp;NUMBER OF&nbsp;REVIEWS</p>
                </div>
                <div class="media-right">
                  <p class="is-size-3 is-height-35 has-text-weight-bold is-pulled-right" v-text="totalReviews"></p>
                </div>
              </article>
              <star-rating-widget class="mar-top is-hidden-mobile non-mobile-view"
                                  :container-border="starRatingBorder"
                                  :final-score="starRatingAverage"
                                  :total-reviews="totalReviews"
                                  :one="starRatingOneStar"
                                  :two="starRatingTwoStar"
                                  :three="starRatingThreeStar"
                                  :four="starRatingFourStar"
                                  :five="starRatingFiveStar"
                                  :hide-logo="starRatingHideLogo"
                                  :small-bars="starRatingSmallBars"
                                  :star-description-text="starRatingHideLogo" ></star-rating-widget>
              <star-rating-widget class="is-hidden-tablet mobile-view"
                                  :container-border="starRatingBorder"
                                  :final-score="starRatingAverage"
                                  :total-reviews="totalReviews"
                                  :one="starRatingOneStar"
                                  :two="starRatingTwoStar"
                                  :three="starRatingThreeStar"
                                  :four="starRatingFourStar"
                                  :five="starRatingFiveStar"
                                  :hide-logo="starRatingHideLogo"
                                  :small-bars="starRatingSmallBars"
                                  :star-description-text="starRatingHideLogo" ></star-rating-widget>
              <p class="is-size-6 mar-top mar-bottom"><span class="has-text-weight-bold">Reviews</span>&nbsp;(month on month)</p>
              <vue-chart class="mar-bottom" chart-type="ComboChart" :columns="reviewsOverTimeColumns" :rows="reviewsOverTimeRows" :options="reviewsOverTimeOptions"></vue-chart>
            </div>
            <div v-if="isFetchingReviewBreakdownData">
              <p class="has-text-centered">
                <img class="small-spinner" src="/static/img/spinner.svg" alt="fetching Review Breakdown..." />
              </p>
            </div>
            <div class="columns is-mobile is-marginless">
              <div class="column is-2">
                <p class="unread" v-text="unreadReviews"></p>
              </div>
              <div class="column">
                <p class="is-size-6 is-uppercase is-height-50"><span class="has-text-weight-bold">unread</span>&nbsp;reviews</p>
              </div>
              <div class="column">
                <a href="/reviews/unread" class="is-pulled-right is-height-50 is-7-mobile">View&nbsp;reviews</a>
              </div>
            </div>
            <div class="columns is-mobile is-marginless">
              <div class="column is-2">
                <p class="reported" v-text="reportedReviews"></p>
              </div>
              <div class="column">
                <p class="is-size-6 is-uppercase is-height-50"><span class="has-text-weight-bold">reported</span>&nbsp;reviews</p>
              </div>
            </div>
          </div>
        </div>
        <!-- NPS Totals -->
        <n-p-s-totals></n-p-s-totals>
      </div>
      <div class="column is-full-tablet is-6-desktop">
        <!-- TrustIndex Breakdown -->
        <div class="card" data-track="TrustIndex &amp; Industry Breakdown">
          <header class="card-header">
            <p class="card-header-title">TrustIndex&nbsp;&amp;&nbsp;Industry&nbsp;<span class="has-text-weight-normal">breakdown</span></p>
          </header>
          <div class="card-content">
            <article class="media grey-back">
              <div class="media-left">
                <figure class="image is-36x42">
                  <img src="/static/img/reviews/trust-index.svg" alt="Global TrustIndex" />
                </figure>
              </div>
              <div class="media-content">
                <p class="is-size-6 is-height-42"><span class="has-text-weight-bold">TRUST</span>INDEX <span class="is-size-7">(based&nbsp;on&nbsp;last&nbsp;12&nbsp;months)</span></p>
              </div>
              <div class="media-right">
                <p class="is-size-3 is-height-42 has-text-weight-bold is-pulled-right" v-text="globalTrustIndex"></p>
              </div>
            </article>
            <article class="media grey-back">
              <div class="media-left">
                <figure class="image is-21x40">
                  <img src="/static/img/reviews/industries.svg" alt="Global Industry Rank" />
                </figure>
              </div>
              <div class="media-content">
                <p class="is-size-6 is-height-40">INDUSTRY RANKING<span class="is-hidden-mobile is-size-7"><br/>(based on last 12 months)</span></p>
              </div>
              <div class="media-right is-height-40">
                <div class="level">
                  <div class="level-item">
                    <p class="is-size-3 is-size-4-mobile has-text-weight-bold" v-text="printIndustryRank"></p>
                  </div>
                  <div class="level-item">
                    <p class="is-size-6 is-size-7-mobile has-text-weight-bold" v-html="printIndustryName"></p>
                  </div>
                </div>
              </div>
            </article>
            <p class="is-size-6">Industry ranking (month on month)</p>
            <div class="columns is-mobile monthly-rank">
              <div v-for="monthRank in monthRanking" class="column is-3">
                <div class="rank-box grey-back">
                  <span class="is-size-5">#{{ monthRank.industryRanking }}</span><br/>
                  <span class="is-size-6" v-text="monthRank.month"></span>
                </div>
              </div>
            </div>
            <div class="level is-hidden-mobile mar-top">
              <div class="level-item level-left">
                <p class="is-size-6"><span class="has-text-weight-bold">TrustIndex</span>&nbsp;(month on month)</p>
              </div>
              <div class="level-item level-right">
                <drop-down data-track="select period" :is-full-width="mobileIsFullWidthDropdown" place-holder="Filter by date..." :items="trustIndexFilterList" v-on:changed="trustIndexFilterSelected" :select-first-item-on-mount="selectFirstOption"></drop-down>
              </div>
            </div>
            <p class="is-hidden-tablet is-fullwidth"><drop-down data-track="select period" :is-full-width="mobileIsFullWidthDropdown" place-holder="Filter by date..." :items="trustIndexFilterList" v-on:changed="trustIndexFilterSelected" :select-first-item-on-mount="selectFirstOption"></drop-down></p>
            <vue-chart v-if="!isFetchingTrustIndex" chart-type="ComboChart" :columns="trustIndexOverTimeColumns" :rows="trustIndexOverTimeRows" :options="trustIndexOverTimeOptions"></vue-chart>
            <div v-if="isFetchingTrustIndex">
              <p class="has-text-centered">
                <img class="small-spinner" src="/static/img/spinner.svg" alt="fetching Trust Index..." />
              </p>
            </div>
          </div>
        </div>
        <!-- Response Time Breakdown -->
        <div class="card" data-track="Time to reply">
          <header class="card-header is-hidden-mobile">
            <p class="card-header-title">Time&nbsp;<span class="has-text-weight-normal">to reply</span></p>
            <p class="card-header-icon has-text-weight-normal">
              <drop-down data-track="select period" place-holder="Filter by date..." :items="filterList" v-on:changed="responseTimeFilterSelected" :select-first-item-on-mount="selectFirstOption"></drop-down>
            </p>
          </header>
          <header class="card-header is-hidden-tablet">
            <p class="card-header-title">Time <span class="has-text-weight-normal">to reply</span></p>
            <p class="is-fullwidth"><drop-down data-track="select period" :is-full-width="mobileIsFullWidthDropdown" place-holder="Filter by date..." :items="filterList" v-on:changed="responseTimeFilterSelected" :select-first-item-on-mount="selectFirstOption"></drop-down></p>
          </header>
          <div class="card-content">
            <div v-if="!isFetchingResponseTimeData">
              <article class="media grey-back">
                <div class="media-left">
                  <figure class="image is-44x45">
                    <img src="/static/img/reviews/response-time.svg" alt="Time to reply" />
                  </figure>
                </div>
                <div class="media-content">
                  <p class="is-size-6 is-size-7-mobile is-height-45">Average time to reply</p>
                </div>
                <div class="media-right">
                  <p class="is-size-3 is-size-4-mobile is-height-45 has-text-weight-bold" v-text="averageResponseTime"></p>
                </div>
                <div class="level-item">
                  <p class="is-size-6 is-size-7-mobile is-height-45 has-text-weight-bold" v-html="printAverageResponseTime"></p>
                </div>
              </article>
              <vue-chart class="mar-top" chart-type="LineChart" :columns="responseTimesColumns" :rows="responseTimesRows" :options="reviewsOverTimeOptions"></vue-chart>
            </div>
            <div v-if="isFetchingResponseTimeData">
              <p class="has-text-centered">
                <img class="small-spinner" src="/static/img/spinner.svg" alt="fetching Response Time data..." />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import DropDown from './../../components/DropDown.vue'
  import NPSTotals from './../../components/NPSTotals.vue'
  import graphMixin from './../../mixins/graphs.js'
  import misc from './../../mixins/misc.js'
  import StarRatingWidget from './../../widgets/StarRatingWidget.vue'
  import moment from 'moment'
  import axios from 'axios'
  import qs from 'qs'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Reviews Dashboard'
    },
    mounted () {
      this.pageLoadEvent()
    },
    name: 'ReviewDashboard',
    components: {
      DropDown,
      StarRatingWidget,
      NPSTotals
    },
    mixins: [graphMixin, misc],
    created () {
      this.updateReviewDashboard()
      window.events.$on('update-review-dashboard', () => {
        this.updateReviewDashboard(true)
      })
    },
    destroyed () {
      window.events.$off('update-review-dashboard')
    },
    data () {
      return {
        responseTimeUrl1: '',
        responseTimeUrl2: '',
        trustIndexFilterUrl1: '',
        trustIndexFilterList: [
          {
            name: 'Previous month',
            value: 'previous_month'
          },
          {
            name: 'Last 6 months',
            value: 'previous_6_months'
          },
          {
            name: 'Last 12 months',
            value: 'last_12_months'
          }
        ],
        businessSlug: '',
        selectFirstOption: true,
        mobileIsFullWidthDropdown: true,
        globalTrustIndex: 0.0,
        globalIndustryRank: 0,
        globalIndustryName: '',
        totalReviews: 271,
        reviewStarData: [],
        starRatingBorder: false,
        starRatingAverage: 0,
        starRatingOneStar: 0,
        starRatingTwoStar: 0,
        starRatingThreeStar: 0,
        starRatingFourStar: 0,
        starRatingFiveStar: 0,
        starRatingHideLogo: true,
        starRatingSmallBars: false,
        unreadReviews: 0,
        reportedReviews: 0,
        responseTimesRows: [],
        responseTimesColumns: [],
        averageResponseTime: 0,
        monthRanking: [],
        isFetchingStarRating: false,
        isFetchingReviewsOverTime: false,
        isFetchingTrustIndex: false,
        isFetchingResponseTime: false,
        isFetchingResponseTimeAverage: false,
        filterReviewSelectedUrl1: '',
        filterReviewSelectedUrl2: ''
      }
    },
    computed: {
      printIndustryRank () {
        if (this.globalIndustryRank > 0) {
          return `#${this.globalIndustryRank}`
        }
        return ``
      },
      printIndustryName () {
        const industryName = this.globalIndustryName.toUpperCase()
        if (industryName.length > 0) {
          return `&nbsp;&nbsp;IN ${industryName}`
        }
        return ``
      },
      printAverageResponseTime () {
        if (this.averageResponseTime > 0) {
          return `&nbsp;&nbsp;HOURS`
        }
        return ``
      },
      isFetchingReviewBreakdownData () {
        return this.isFetchingStarRating && this.isFetchingReviewsOverTime
      },
      isFetchingResponseTimeData () {
        return this.isFetchingResponseTimeAverage && this.isFetchingResponseTime
      }
    },
    methods: {
      /**
       * page load event
       *
       * @returns {void}
       */
      pageLoadEvent () {
        this.$gtm.trackEvent({
          event: 'pageLoad',
          virtualPageUrl: this.$router.currentRoute.path,
          virtualPageTitle: 'Reviews Dashboard'
        })
      },
      /**
       * Update review dashboard while switching business profile from review dashboard
       *
       * @param {boolean}  pageload value is for checking boolean value
       * @returns {void}
       */
      updateReviewDashboard (pageload = false) {
        this.businessSlug = localStorage.getItem('org_slug')
        this.getGlobalTrustIndexAndIndustryRanking()
        this.getGlobalUnreadAndReportedReviewCounts()
        this.updateFilterList()
        if (pageload) {
          location.reload()
        }
      },
      /**
       * Get Global Trust Index and Industry Ranking - not affected by date filters and displays current results
       *
       * @returns {void}
       */
      getGlobalTrustIndexAndIndustryRanking () {
        const errMessage = 'We encountered a problem retrieving your TrustIndex and Industry Ranking, please try again later'
        axios.get(`/${this.businessSlug}/reports/trust-index`)
                .then(({data}) => {
                  if (typeof data.trustIndex !== 'undefined' && typeof data.industryRanking !== 'undefined') {
                    this.globalTrustIndex = data.trustIndex
                    this.globalIndustryRank = data.industryRanking
                    this.globalIndustryName = data.industryName
                    this.monthRanking = data.months
                  } else {
                    flash(errMessage, 'is-warning')
                    dataLayer.push({
                      'userMessage': {
                        'messageType': 'error',
                        'messageName': 'Failed to retrieve your TrustIndex and Industry Ranking on Review Dashboard',
                        'displayedMessage': errMessage
                      }
                    })
                  }
                })
                .catch(() => {
                  flash(errMessage, 'is-danger')
                  dataLayer.push({
                    'userMessage': {
                      'messageType': 'error',
                      'messageName': 'Failed to retrieve your TrustIndex and Industry Ranking on Review Dashboard',
                      'displayedMessage': errMessage
                    }
                  })
                })
      },
      /**
       * Get Global Unread and Reported, unprocessed reviews - not affected by date filters and displays current results
       *
       * @returns {void}
       */
      getGlobalUnreadAndReportedReviewCounts () {
        axios.get(`/${this.businessSlug}/unread-and-reported-review-counts`)
                .then(({data}) => {
                  this.unreadReviews = data.unread
                  this.reportedReviews = data.reported
                })
                .catch(() => {
                  flash('We encountered a problem retrieving your unread and reported reviews, please try again later', 'is-danger')
                  dataLayer.push({
                    'userMessage': {
                      'messageType': 'error',
                      'messageName': 'Failed to retrieve your unread and reported reviews on Review Dashboard',
                      'displayedMessage': 'We encountered a problem retrieving your unread and reported reviews, please try again later'
                    }
                  })
                })
      },
      reviewFilterSelected (event) {
        const dateQuery = this.dateFilters(qs, moment, event.value, true)
        const starRatingTracking = qs.stringify({
          track_activity_action: 'response.times.breakdown.view',
          track_activity_event: 'ReviewDashBoardActivity'
        })
        const reviewsOverTimeTracking = qs.stringify({
          track_activity_action: 'reviews.over.time.view',
          track_activity_event: 'ReviewDashBoardActivity'
        })
        const filterReviewSelectedUrl1 = `/${this.businessSlug}/reports/star-rating?${dateQuery}&${starRatingTracking}`
        const filterReviewSelectedUrl2 = `/${this.businessSlug}/reports/over-time?${dateQuery}&${reviewsOverTimeTracking}`
        if (filterReviewSelectedUrl1 !== this.filterReviewSelectedUrl1 && filterReviewSelectedUrl2 !== this.filterReviewSelectedUrl2) {
          this.isFetchingStarRating = true
          this.isFetchingReviewsOverTime = true
          this.filterReviewSelectedUrl1 = filterReviewSelectedUrl1
          this.filterReviewSelectedUrl2 = filterReviewSelectedUrl2
          // get star rating data
          axios.get(`/${this.businessSlug}/reports/star-rating?${dateQuery}&${starRatingTracking}`)
            .then(({data}) => {
              this.reviewStarData = data.rows.reverse()
              let newTotal = 0
              data.rows.forEach((row) => {
                switch (row[0]) {
                  case '1 Star':
                    this.starRatingOneStar = row[1]
                    break
                  case '2 Stars':
                    this.starRatingTwoStar = row[1]
                    break
                  case '3 Stars':
                    this.starRatingThreeStar = row[1]
                    break
                  case '4 Stars':
                    this.starRatingFourStar = row[1]
                    break
                  case '5 Stars':
                    this.starRatingFiveStar = row[1]
                    break
                  default:
                    break
                }
                newTotal += row[1]
              })
              this.starRatingAverage = 0.0
              this.totalReviews = newTotal
              if (newTotal > 0) {
                let one = this.starRatingOneStar
                let two = this.starRatingTwoStar * 2
                let three = this.starRatingThreeStar * 3
                let four = this.starRatingFourStar * 4
                let five = this.starRatingFiveStar * 5
                this.starRatingAverage = parseFloat(((one + two + three + four + five) / newTotal).toFixed(1))
              }
              this.isFetchingStarRating = false
            })
            .catch(() => {
              this.isFetchingStarRating = false
              flash('We encountered a problem retrieving your average rating, please try again later', 'is-danger')
              dataLayer.push({
                'userMessage': {
                  'messageType': 'error',
                  'messageName': 'Failed to retrieve star rating on Review Dashboard',
                  'displayedMessage': 'We encountered a problem retrieving your average rating, please try again later'
                }
              })
            })
          // get reviews over time
          axios.get(`/${this.businessSlug}/reports/over-time?${dateQuery}&${reviewsOverTimeTracking}`)
            .then(({data}) => {
              this.reviewsOverTimeColumns = data.columns
              this.reviewsOverTimeRows = data.rows
              this.reviewsOverTimeOptions = this.trustIndexOverTimeOptions
              this.reviewsOverTimeOptions.vAxis = {
                title: '',
                textStyle: {
                  color: '#7b7c7e',
                  bold: true
                }
              }
              this.isFetchingReviewsOverTime = false
            })
            .catch(() => {
              this.isFetchingReviewsOverTime = false
              flash('We encountered a problem retrieving your reviews for the given time period, please try again later', 'is-danger')
              dataLayer.push({
                'userMessage': {
                  'messageType': 'error',
                  'messageName': 'Failed to retrieve reviews over time on Review Dashboard',
                  'displayedMessage': 'We encountered a problem retrieving your reviews for the given time period, please try again later'
                }
              })
            })
        }
      },
      trustIndexFilterSelected (event) {
        const dateQuery = this.dateFilters(qs, moment, event.value)
        const trustIndexOverTimeTracking = qs.stringify({
          track_activity_action: 'trust.index.over.time.view',
          track_activity_event: 'ReviewDashBoardActivity'
        })
        const trustIndexFilterUrl1 = `/${this.businessSlug}/reports/trust-index-over-time?${dateQuery}&${trustIndexOverTimeTracking}`
        if (this.trustIndexFilterUrl1 !== trustIndexFilterUrl1) {
          this.trustIndexFilterUrl1 = trustIndexFilterUrl1
          this.isFetchingTrustIndex = true
          axios.get(`/${this.businessSlug}/reports/trust-index-over-time?${dateQuery}&${trustIndexOverTimeTracking}`)
              .then(({data}) => {
                this.trustIndexOverTimeRows = data.rows
                this.trustIndexOverTimeColumns = data.columns
                this.trustIndexOverTimeOptions.chartArea.bottom = '15%'
                this.trustIndexOverTimeOptions.height = '250'
                this.isFetchingTrustIndex = false
              })
              .catch(() => {
                this.isFetchingTrustIndex = false
                flash('We had a problem retrieving your TrustIndex breakdown for the given time period, please try again later.', 'is-danger')
                dataLayer.push({
                  'userMessage': {
                    'messageType': 'error',
                    'messageName': 'Failed to retrieve your TrustIndex over time on Review Dashboard',
                    'displayedMessage': 'We had a problem retrieving your TrustIndex breakdown for the given time period, please try again later.'
                  }
                })
              })
        }
      },
      responseTimeFilterSelected (event) {
        const dateQuery = this.dateFilters(qs, moment, event.value)
        const responseTimesTracking = qs.stringify({
          track_activity_action: 'response.times.breakdown.view',
          track_activity_event: 'ReviewDashBoardActivity'
        })
        const responseTimeUrl1 = `/${this.businessSlug}/reports/response-times-breakdown?${dateQuery}&${responseTimesTracking}`
        const responseTimeUrl2 = `/${this.businessSlug}/reports/single-response-times-average?${dateQuery}`
        if (this.responseTimeUrl1 !== responseTimeUrl1 && this.responseTimeUrl2 !== responseTimeUrl2) {
          this.responseTimeUrl1 = responseTimeUrl1
          this.responseTimeUrl2 = responseTimeUrl2
          this.isFetchingResponseTime = true
          this.isFetchingResponseTimeAverage = true
          axios.get(`/${this.businessSlug}/reports/response-times-breakdown?${dateQuery}&${responseTimesTracking}`)
            .then(({data}) => {
              let responseRows = data.rows
              if (!Array.isArray(responseRows)) {
                this.responseTimesRows = Object.entries(responseRows)
              } else {
                this.responseTimesRows = data.rows
              }
              this.responseTimesColumns = data.columns
              this.isFetchingResponseTime = false
            })
            .catch(() => {
              this.isFetchingResponseTime = false
              flash('We could not retrieve your average time to reply for the given period. Please try again later.', 'is-danger')
              dataLayer.push({
                'userMessage': {
                  'messageType': 'error',
                  'messageName': 'Failed to retrieve your average time to reply on Review Dashboard',
                  'displayedMessage': 'We could not retrieve your average time to reply for the given period. Please try again later.'
                }
              })
            })

          axios.get(`/${this.businessSlug}/reports/single-response-times-average?${dateQuery}`)
            .then(({data}) => {
              this.averageResponseTime = data
              this.isFetchingResponseTimeAverage = false
            })
            .catch(() => {
              this.isFetchingResponseTimeAverage = false
              flash('We had a problem retrieving your Average Review Response Time for the given time period, please try again later.', 'is-danger')
              dataLayer.push({
                'userMessage': {
                  'messageType': 'error',
                  'messageName': 'Failed to retrieve your average review response time on Review Dashboard',
                  'displayedMessage': 'We had a problem retrieving your Average Review Response Time for the given time period, please try again later'
                }
              })
            })
        }
      }
    }
  }
</script>
<style scoped>
  .grey-back {
    background-color: #F5F5F5;
    color: #58595B;
    padding: 0.75rem 1.5rem 0.75rem 1rem;
  }

  .is-36x42 {
    width: 36px;
    height: 42px;
  }

  .is-21x40 {
    width: 21px;
    height: 40px;
    margin-left: 7px;
    margin-right: 8px;
  }

  .is-41x35 {
    width: 41px;
    height: 35px;
  }

  .is-44x45 {
    width: 45px;
    height: 45px;
  }

  .is-height-45 {
    height: 45px;
    line-height: 45px;
  }

  .is-height-35 {
    height: 35px;
    line-height: 35px;
  }

  .is-height-40 {
    height: 40px;
    line-height: 40px;
  }

  .is-height-42 {
    height: 42px;
    line-height: 42px;
  }

  .is-height-50 {
    height: 50px;
    line-height: 50px;
  }

  a.is-height-50 {
    text-decoration: underline;
  }

  .media + .media {
    border: none;
  }

  figure img {
    border-radius: 0;
  }

  .mar-top {
    margin-top: 2rem;
  }

  .mar-bottom {
    margin-bottom: 1rem;
  }

  .unread {
    color: #ffffff;
    background-color: #30AAE1;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    text-align: center;
    font-weight: bold;
    line-height: 50px;
  }

  .reported {
    color: #ffffff;
    background-color: #EAB013;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    text-align: center;
    font-weight: bold;
    line-height: 50px;
  }

  .rank-box {
    display: block;
    width: 100%;
    height: auto;
    font-weight: bold;
    text-align: center;
  }

  .monthly-rank > .column:first-child {
    padding-left: 0;
  }

  .small-spinner {
    max-width: 40px!important;
  }

  .media-content > .is-height-40 {
    line-height: 18px;
  }

  .mobile-view.star-rating-widget >>> .star-row {
    padding-left: 25px;
  }

  .mobile-view.star-rating-widget >>> .star-row ul {
    width: 100%;
  }

  @media screen and (max-width: 768px) {
   .non-mobile-view.star-rating-widget >>> li {
      font-size: 1.5em;
    }
  }

  @media screen and (max-width: 1680px) and (min-width: 1024px) {
    .non-mobile-view.star-rating-widget >>> ul {
      width: 100%;
    }
  }

  @media screen and (max-width: 1172px) and (min-width: 1024px) {
    .non-mobile-view.star-rating-widget >>> .column.is-6-mobile.is-5-tablet.level-item {
      width: 35%;
    }

    .non-mobile-view.star-rating-widget >>> .column.is-hidden-mobile.is-4.hero {
      width: 40%;
    }
  }

  @media screen and (max-width: 1345px) and (min-width: 1216px) {
    .non-mobile-view.star-rating-widget >>> .column.is-hidden-mobile.is-4.hero {
      width: 38%;
    }
  }

  @media screen and (max-width: 767px) {
    .card-content {
      padding: 1.5rem 0.75rem;
    }

    .is-height-35 {
      height: 50px;
      line-height: 25px;
    }

    .is-41x35 {
      margin-top: 7px;
    }

    .media-right > .is-height-35 {
      line-height: 50px;
    }

    .is-height-42 {
      line-height: 22px;
    }

    .media-right > .is-height-42 {
      line-height: 42px;
    }

    .is-height-40 {
      line-height: 20px;
    }

    .is-height-40 > .level > .level-item {
      margin-bottom: 0;
    }

    .media-content > .is-height-45 {
      line-height: 22px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/ReviewDashboard.vue